<div class="content-layout fullwidth-standard-normal-scroll">
  <div class="header">
    <div class="container">
      <h1>Dropdowns</h1>
    </div>
  </div>

  <div class="main">
    <div class="flex flex-wrap w-full">
      <div class="flex flex-col w-6/12">
        <settings-stages-sortable-dropdown-editor
          title="Deal Status"
          [options]="projectStages"
          showColor="true"
          showRequiredFields="true"
          [relatedToType]="'Project'"
          (onUpdate)="updateProjectStage($event)"
          (onAdd)="addProjectStage($event)"
          (rankChanged)="onRankChanged($event, 'ProjectStage')"
          [pipelines]="pipelines"
        ></settings-stages-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Property Types"
          [options]="propertyTypes"
          showColor="true"
          (onUpdate)="updatePropertyType($event)"
          (onAdd)="addPropertyType($event)"
          (rankChanged)="onRankChanged($event, 'PropertyType')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Deal Types"
          [options]="projectTypes"
          (onUpdate)="updateProjectType($event)"
          (onAdd)="addProjectType($event)"
          (rankChanged)="onRankChanged($event, 'ProjectType')"
        ></settings-sortable-dropdown-editor>

        <settings-stages-sortable-dropdown-editor
          title="Deal Phases"
          [options]="projectPhases"
          [pipelines]="pipelines"
          (onUpdate)="updateProjectPhase($event)"
          (onAdd)="addProjectPhase($event)"
          (rankChanged)="onRankChanged($event, 'ProjectPhase')"
          showRequiredFields="true"
        ></settings-stages-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Call Outcomes"
          [options]="callOutcomes"
          (onUpdate)="updateCallOutcome($event)"
          (onAdd)="addCallOutcome($event)"
          (rankChanged)="onRankChanged($event, 'CallOutcome')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Meeting Outcomes"
          [options]="meetingOutcomes"
          (onUpdate)="updateMeetingOutcome($event)"
          (onAdd)="addMeetingOutcome($event)"
          (rankChanged)="onRankChanged($event, 'MeetingOutcome')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Activity Types"
          [options]="engagementActivityTypes"
          (onUpdate)="updateEngagementActivityType($event)"
          (onAdd)="addEngagementActivityType($event)"
          (rankChanged)="onRankChanged($event, 'EngagementActivityType')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Social Media Sources"
          [options]="socialMediaSources"
          (onUpdate)="updateSocialMediaSource($event)"
          (onAdd)="addSocialMediaSource($event)"
          (rankChanged)="onRankChanged($event, 'SocialMediaSource')"
        ></settings-sortable-dropdown-editor>
      </div>
      <div class="flex flex-col w-6/12">
        <settings-sortable-dropdown-editor
          title="Investment Types"
          [options]="investmentTypes"
          (onUpdate)="updateInvestmentType($event)"
          (onAdd)="addInvestmentType($event)"
          (rankChanged)="onRankChanged($event, 'InvestmentType')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Market Status"
          [options]="marketStatuses"
          (onUpdate)="updateMarketStatus($event)"
          (onAdd)="addMarketStatus($event)"
          (rankChanged)="onRankChanged($event, 'MarketStatus')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Contact Types"
          [options]="categories"
          (onUpdate)="updateCategory($event)"
          (onAdd)="addCategory($event)"
          (rankChanged)="onRankChanged($event, 'Category')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Vehicles"
          [options]="vehicles"
          (onUpdate)="updateVehicle($event)"
          (onAdd)="addVehicle($event)"
          (rankChanged)="onRankChanged($event, 'Vehicle')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Teams"
          [options]="teams"
          (onUpdate)="updateTeam($event)"
          (onAdd)="addTeam($event)"
          (rankChanged)="onRankChanged($event, 'Team')"
        ></settings-sortable-dropdown-editor>

        <settings-sortable-dropdown-editor
          title="Loan Purposes"
          [options]="loanPurposes"
          (onUpdate)="updateLoanPurpose($event)"
          (onAdd)="addLoanPurpose($event)"
          (rankChanged)="onRankChanged($event, 'LoanPurpose')"
        ></settings-sortable-dropdown-editor>
        <settings-sortable-dropdown-editor
          title="Layouts"
          [options]="projectTemplates"
          [relatedToOptionsMap]="customObjectLabelMap"
          (onUpdate)="updateProjectTemplate($event)"
          (onAdd)="addProjectTemplate($event)"
          (rankChanged)="onRankChanged($event, 'ProjectTemplate')"
          disableAddNew="true"
        ></settings-sortable-dropdown-editor>
      </div>
    </div>
  </div>
</div>
